export const config = {
  socketHost: process.env.NODE_ENV === 'production'
    ? 'https://gdainti.com'
    : 'http://localhost:3003',
    // for device debugging
    //: 'http://192.168.0.174:3003',
}